import React from 'react';
import careersimage from '../BitsImages/careersimage.jpg';

const CareersMain = () => {
  return (
  <>
  <div>
  <br/>
  <br/>
  <br/>
<img src={careersimage} alt="careersimage" style={{width:'100%'}}/>
</div>
  </>
  );
};

export default CareersMain;
